<div class="row">
  <div class="col-lg-6">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 images" id="Imagen_Error_500">
          <div>
            <img src="./assets/img/500.png" alt="Error 500" title="Error 500" class="image">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 html m-auto py-5 mb-5" id="Texto_gracias_error_404">
          <div class="content">
            <div>
              <p class="h1 text-white">500</p>
            </div>
            <div>
              <p class="h2 text-white mb-3">¡Ups, Ocurrió un error en nuestros servidores!</p>
            </div>
            <div>
              <p class="h4 text-white">No te preocupes, siempre estás a tiempo de alcanzar lo que querés.</p>
            </div>
          </div>
        </div>
        <div class="button col-lg-12"><a href="/" id="Button_error" class="button-orange mb-5">Regresá
            al Home</a>
        </div>
      </div>
    </div>
  </div>
</div>

